// Get the container
const slideContainerASSCANLook1 = document.querySelector('.ASSCANLook1');

// URLs for desktop images
const desktopImageUrlsASSCANLook1 = [
 'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroDesktop.jpg?v=1732111932',
 'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroDesktop2.jpg?v=1732109699',
 'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroDesktop3.jpg?v=1732109699',
 'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroDesktop4.jpg?v=1732109699',
 'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroDesktop5.jpg?v=1732109699',
 'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroDesktop6.jpg?v=1732109699',
 'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroDesktop7.jpg?v=1732109699',
 'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroDesktop8.jpg?v=1732109699',
 'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroDesktop9.jpg?v=1732109699',
 'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroDesktop10.jpg?v=1732109699'
];

// URLs for mobile images
const mobileImageUrlsASSCANLook1 = [
   'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroMobile.jpg?v=1732111932',
   'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroMobile2.jpg?v=1732111240',
   'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroMobile3.jpg?v=1732111240',
   'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroMobile4.jpg?v=1732111240',
   'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroMobile5.jpg?v=1732111240',
   'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroMobile6.jpg?v=1732111240',
   'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroMobile7.jpg?v=1732111241',
   'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroMobile8.jpg?v=1732111240',
   'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/JinroMobile9.jpg?v=1732111240'
];

// Function to determine screen size and load appropriate images
function loadImagesASSCANLook1() {
    const isMobile = window.innerWidth <= 768;
    console.log('isMobile:', isMobile); // Log whether the device is identified as mobile

    // Clear the container
    slideContainerASSCANLook1.innerHTML = '';

    if (isMobile) {
        console.log('Loading mobile images'); // Log the action of loading mobile images
        mobileImageUrlsASSCANLook1.forEach((url, index) => {
            const mobileImage = document.createElement('img');
            mobileImage.src = `${url}?cache_buster=${Date.now()}`; // Force cache busting
            mobileImage.alt = `Mobile image ${index + 1}`;
            mobileImage.className = 'mobile-image-ASSCANLook1';
            slideContainerASSCANLook1.appendChild(mobileImage);
        });
    } else {
        console.log('Loading desktop images'); // Log the action of loading desktop images
        desktopImageUrlsASSCANLook1.forEach((url, index) => {
            const desktopImage = document.createElement('img');
            desktopImage.src = `${url}?cache_buster=${Date.now()}`; // Force cache busting
            desktopImage.alt = `Desktop image ${index + 1}`;
            desktopImage.className = 'desktop-image-ASSCANLook1';
            slideContainerASSCANLook1.appendChild(desktopImage);
        });
    }
}

// Throttle function to avoid excessive firing on resize
function throttle(func, delay) {
    let timeoutId;
    return function () {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            func();
        }, delay);
    };
}

// Call the function initially
document.addEventListener("DOMContentLoaded", function() {
    loadImagesASSCANLook1();

    // Listen for window resize events to update images if necessary
    window.addEventListener('resize', throttle(loadImagesASSCANLook1, 500));

    // Set the target end time (June 6, 2024, at 11:00 AM ET)
    const targetEndTimeASSCANLook1 = new Date('2024-06-06T11:00:00-04:00').getTime();

    function updateCountdownASSCANLook1() {
        const currentTime = new Date().getTime();
        const timeDifference = targetEndTimeASSCANLook1 - currentTime;

        // Check if the countdown has ended
        if (timeDifference <= 0) {
            document.getElementById('countdown-ASSCANLook1').textContent = "Ready!";
            return;
        }

        const hours = Math.floor(timeDifference / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        document.getElementById('countdown-ASSCANLook1').textContent = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

        setTimeout(updateCountdownASSCANLook1, 1000);
    }

    updateCountdownASSCANLook1();
});
